import { Link, Typography } from '@mui/material'
import { Box } from '@mui/system'
import SupportIcon from '@mui/icons-material/Support'
import { SUPPORT_URL } from '../../../constants/supportLinks'

export function Footer (): JSX.Element {
  const year = new Date().getFullYear()

  return <>
    <Box sx={{ backgroundColor: 'var(--off-white)', position: 'fixed', zIndex: '1201', bottom: '0', display: 'flex', justifyContent: 'center', width: '100%', height: '29px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignContent: 'center' }}>
        <Typography sx={{ alignContent: 'center' }} variant='body1'>© Copyright {year} START Project</Typography>
        <Link
          sx={{
            cursor: 'pointer',
            alignContent: 'center',
            ml: '2em',
            color: 'var(--grey-900)',
            fontWeight: 400
          }}
          onClick={() => {
            window.open(SUPPORT_URL, '_blank')
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row', alignContent: 'center' }}>
            <SupportIcon />
            <Typography sx={{ ml: '.5em' }} variant='body1'>Support</Typography>
          </Box>
        </Link>
      </Box>
    </Box>
  </>
}
